// Rotation des messages de la barre promo. Pause au survol, au focus et via le bouton (WCAG 2.2.2).
if (!customElements.get('mp-barre-promo')) {
  class MpBarrePromo extends HTMLElement {
    connectedCallback() {
      this.messages = [...this.querySelectorAll('.mp-barre-promo__message')];
      this.bouton = this.querySelector('.mp-barre-promo__pause');
      if (this.messages.length < 2) return;

      this.index = 0;
      this.vitesse = Number(this.dataset.vitesse) || 5000;
      this.enPauseUtilisateur = false;
      this.enPauseSurvol = false;

      this.addEventListener('mouseenter', () => (this.enPauseSurvol = true));
      this.addEventListener('mouseleave', () => (this.enPauseSurvol = false));
      this.addEventListener('focusin', () => (this.enPauseSurvol = true));
      this.addEventListener('focusout', () => (this.enPauseSurvol = false));
      this.bouton?.addEventListener('click', () => this.basculerPause());
      this.querySelector('[data-mp-barre-precedent]')?.addEventListener('click', () => this.deplacer(-1));
      this.querySelector('[data-mp-barre-suivant]')?.addEventListener('click', () => this.deplacer(1));

      this.minuteur = setInterval(() => this.suivant(), this.vitesse);
    }

    disconnectedCallback() {
      clearInterval(this.minuteur);
    }

    suivant() {
      if (this.enPauseUtilisateur || this.enPauseSurvol) return;
      this.afficher((this.index + 1) % this.messages.length);
    }

    // Navigation manuelle : relance le délai pour laisser le temps de lire
    deplacer(sens) {
      this.afficher((this.index + sens + this.messages.length) % this.messages.length);
      clearInterval(this.minuteur);
      this.minuteur = setInterval(() => this.suivant(), this.vitesse);
    }

    afficher(index) {
      const sortant = this.messages[this.index];
      sortant.classList.remove('is-active');
      sortant.classList.add('is-sortant');
      sortant.setAttribute('aria-hidden', 'true');
      setTimeout(() => sortant.classList.remove('is-sortant'), 700);
      this.index = index;
      this.messages[this.index].classList.add('is-active');
      this.messages[this.index].removeAttribute('aria-hidden');
    }

    basculerPause() {
      this.enPauseUtilisateur = !this.enPauseUtilisateur;
      this.bouton.setAttribute('aria-pressed', String(this.enPauseUtilisateur));
      this.bouton.setAttribute(
        'aria-label',
        this.enPauseUtilisateur ? this.bouton.dataset.libelleLecture : this.bouton.dataset.libellePause
      );
    }
  }

  customElements.define('mp-barre-promo', MpBarrePromo);

  // Éditeur de thème : afficher le message sélectionné
  document.addEventListener('shopify:block:select', (event) => {
    const barre = event.target.closest('mp-barre-promo');
    if (!barre?.messages) return;
    const index = barre.messages.indexOf(event.target);
    if (index >= 0) {
      barre.enPauseUtilisateur = true;
      barre.afficher(index);
    }
  });
}
